export default __webpack_public_path__ + "static/media/change.4544e264.svg";